"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _get = _interopRequireDefault(require("lodash/get"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _LoadingOverlay = _interopRequireDefault(require("../../../../../Framework/Components/LoadingOverlay"));
var _CustomDialog = _interopRequireDefault(require("../../../../../Shared/Components/CustomDialog"));
var _customClassName = _interopRequireDefault(require("../../../../Utils/customClassName"));
var _Option = _interopRequireDefault(require("../Option"));
var _excluded = ["render"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _dialogStyle, _theme$breakpoints$be2, _ref;
  return _ref = {
    dialogStyle: (_dialogStyle = {
      height: '100%'
    }, _defineProperty(_dialogStyle, theme.breakpoints.down('sm'), {
      width: '100%',
      maxWidth: '390px'
    }), _defineProperty(_dialogStyle, theme.breakpoints.between('sm', 'xl'), {
      width: '470px',
      maxWidth: '470px'
    }), _defineProperty(_dialogStyle, theme.breakpoints.up('md'), {
      marginLeft: '120px',
      '& .MuiBackdrop-root': {
        left: '140px'
      }
    }), _dialogStyle)
  }, _defineProperty(_ref, theme.breakpoints.between('sm', 'md'), _defineProperty({}, theme.orientation.portrait, {
    top: '-110px !important'
  })), _defineProperty(_ref, '& > div.MuiDialog-container', _defineProperty({}, theme.breakpoints.between('sm', 'lg'), (_theme$breakpoints$be2 = {}, _defineProperty(_theme$breakpoints$be2, theme.orientation.portrait, {
    alignItems: 'flex-end'
  }), _defineProperty(_theme$breakpoints$be2, theme.orientation.landscape, {
    alignItems: 'flex-start',
    marginTop: 35
  }), _theme$breakpoints$be2))), _defineProperty(_ref, "contentStyle", {}), _defineProperty(_ref, "backDrop", {
    backgroundColor: 'rgba(0,0,0,0.0)'
  }), _ref;
}, {
  name: 'OptionsList'
});
var OptionsList = function OptionsList(_ref2) {
  var render = _ref2.render,
    props = _objectWithoutProperties(_ref2, _excluded);
  var addCheckedOptionclassification = props.addCheckedOptionclassification,
    children = props.children,
    isLoading = props.isLoading,
    onClose = props.onClose,
    onSelect = props.onSelect,
    onToggle = props.onToggle,
    optionclassification = props.optionclassification,
    options = props.options,
    show = props.show,
    viewDetails = props.viewDetails,
    viewStockInformation = props.viewStockInformation,
    LoadingComponent = props.LoadingComponent,
    OptionComponent = props.OptionComponent,
    isAdminMode = props.isAdminMode,
    setOptionInputText = props.setOptionInputText;
  var classes = useStyles();
  var createOptions = function createOptions() {
    var onOptionClicked = function onOptionClicked() {
      addCheckedOptionclassification(optionclassification);
    };
    return options.map(function (option) {
      var optionIndex = -1;
      var optionGroupChildren = (0, _get["default"])(option, 'option_group.children', []);
      if (optionGroupChildren.length === 0) {
        optionIndex = (0, _findIndex["default"])((0, _get["default"])(optionclassification, 'selectedoptions'), {
          identifier: option.identifier
        });
      } else {
        var _iterator = _createForOfIteratorHelper(optionGroupChildren),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            optionIndex = (0, _findIndex["default"])((0, _get["default"])(optionclassification, 'selectedoptions'), {
              identifier: item.identifier
            });
            if (optionIndex > -1) {
              // we need the first selected option
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      var selected = optionIndex <= -1 ? false : !(option.amount_is_selectable && option.amount < 1);
      return /*#__PURE__*/_react["default"].createElement(OptionComponent, {
        key: 'optionlistitem' + option.identifier,
        option: option,
        optionclassification: optionclassification,
        onSelect: onSelect,
        selected: selected,
        viewDetails: viewDetails,
        viewStockInformation: viewStockInformation,
        onClick: onOptionClicked,
        onInputTextChange: setOptionInputText,
        onToggle: onToggle,
        isAdminMode: isAdminMode
      });
    });
  };
  var renderOptions = function renderOptions() {
    var optionListItems = createOptions();
    return /*#__PURE__*/_react["default"].createElement("div", null, children ? children : optionListItems.length > 0 ? optionListItems : null, /*#__PURE__*/_react["default"].createElement(LoadingComponent, {
      show: isLoading
    }));
  };
  var renderOptionsList = function renderOptionsList() {
    return /*#__PURE__*/_react["default"].createElement(_CustomDialog["default"], {
      className: (0, _clsx["default"])(classes.dialogStyle, (0, _customClassName["default"])('options')),
      dialogTitle: optionclassification.title,
      onCancel: onClose,
      onClose: onClose,
      open: show && !!optionclassification.identifier,
      BackdropProps: {
        classes: {
          root: classes.backDrop
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
      className: classes.contentStyle
    }, renderOptions()));
  };
  var getRenderProps = function getRenderProps() {
    return _objectSpread(_objectSpread({}, props), {}, {
      renderOptions: renderOptions,
      createOptions: createOptions,
      renderOptionsList: renderOptionsList
    });
  };
  return typeof render === 'function' ? render(getRenderProps()) : renderOptionsList();
};
OptionsList.defaultProps = {
  addCheckedOptionclassification: function addCheckedOptionclassification() {},
  isLoading: false,
  onClose: function onClose() {},
  onSelect: function onSelect() {},
  onToggle: function onToggle() {},
  options: [],
  optionclassification: {},
  show: false,
  viewDetails: function viewDetails() {},
  viewStockInformation: function viewStockInformation() {},
  LoadingComponent: _LoadingOverlay["default"],
  OptionComponent: _Option["default"]
};
var _default = exports["default"] = OptionsList;